import React, { useEffect, useState, useContext } from 'react'
import { Col, Row, Card } from 'react-bootstrap';
import { FaCalendarAlt } from "react-icons/fa"
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { Link, useParams } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import Get from '../../api/Get'
import { APPOINTMENTS_BY_DOCTOR, DOCTOR_BY_EMAIL } from '../../api/Routes'
import { authContext } from "../../context/AuthContext";
import LoadingList from "../../loader/LoadingList";
import ComponentModalErrorSever from '../../components/ComponentModalErrorSever'

import '../../styles/doctores/pacientes.css'

const MisPacientes = ({ t, url }) => {
    const {doctorID} = useParams()
    const [idDoctor, setIdDoctor] = useState(doctorID)
    const [pacientes, setPacientes] = useState([])
    const [loading, setLoading] = useState()

    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    //Token de autentificación para los servicios
    const { auth } = useContext(authContext)

    //Información del doctor
    useEffect(() => {

        if(!idDoctor){
            let mounted = true
            const url = encodeURI(`${DOCTOR_BY_EMAIL}/${auth.data.username}`)
            setLoading(true)

            Get({url: url, access_token: auth.data.access_token})
            .then((response) => {
                if(mounted){
                    setIdDoctor(response.data.data.id)
                }
                setLoading(false)
            })
            .catch((error) => {
                setLoading(false)
                setShowModalError(true)
                if(error.response){
                    setErrorServer(error.response)
                }
            })
            return () => mounted = false;
        }
    }, [])

    useEffect(() => {
        if(idDoctor){
            let mounted = true
            const url = encodeURI(`${APPOINTMENTS_BY_DOCTOR}/${idDoctor}`)
            let items = []
            setLoading(true)

            Get({url: url, access_token: auth.data.access_token})
            .then((resp) => {
                if(mounted){
                    let data = resp.data.data.response;
                    data.forEach(element => element.patients.forEach( p => items.push(p)));
                    setPacientes(items)
                }
                setLoading(false)
            })
            .catch((error) => {
                setLoading(false)
                setShowModalError(true)
                if(error.response){
                    setErrorServer(error.response)
                }
            })
            return () => mounted = false;
        }
    }, [idDoctor])

    const name = (cell, row) => `${row?.name ? `${row?.name} ${row?.middleName ?? ''} ${row?.lastName} ${row?.seccondSurname ?? ''}` : ''}`

    const actions = (cell, row) =>  <ul className="list-inline mb-0">
        <li className="list-inline-item">
            <Link to={`${url}/proveedor/citas/${idDoctor}/${row.id}`}>
                <FaCalendarAlt className='iconAction colorVerde cliced' />
            </Link>
        </li>
    </ul>

    const columns = [{
        text: 'ID',
        dataField: 'id',
        headerStyle: { width: '10%' },
        hidden: true
    }, {
        text: t('Nombre'),
        dataField: 'name',
        formatter: name,
        headerStyle: { 
            width: '40%', 
            textTransform: 'uppercase' 
        }
    }, {
        text: t('Correoelectronico'),
        dataField: 'email',
        headerStyle: { 
            width: '40%', 
            textTransform: 'uppercase' 
        }
    }, {
        dataField: '',
        isDummyField: true,
        text: t('citas'),
        headerStyle: { 
            width: '30%', 
            textTransform: 'uppercase' 
        },
        formatter: actions,
    }]

    const { SearchBar } = Search;

    return ( <>
        { loading && <LoadingList texto='' /> }

        <div className='body'>


            <ToolkitProvider
                keyField="id"
                data={ pacientes }
                columns={ columns }
                search
                >
                {
                    props => (
                    <>
                        <Row>
                            <Col xs="12" md="8">
                                <h2 className="mb-0 title-top">{ t('pacientes') }</h2>
                            </Col>
                            <Col xs="12" md="4" className='text-right'>
                                <Row className="align-items-center">
                                    <Col>
                                        <SearchBar { ...props.searchProps } 
                                            placeholder={ t('buscar') }
                                            className="input-search"
                                        />
                                    </Col>
                                </Row>    
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Card className="shadow-1 mt-3">
                                    <Card.Body>
                                    <BootstrapTable 
                                        { ...props.baseProps }
                                            keyField='id' 
                                            data={ pacientes } 
                                            columns={ columns } 
                                            bordered={false}
                                            classes="border-top-0 simple-table"
                                            wrapperClasses="table-responsive-md"
                                            noDataIndication="No hay información disponible"
                                            pagination={ paginationFactory() }
                                    />
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </>
                    )
                }
            </ToolkitProvider>
        </div>
        <ComponentModalErrorSever 
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            /> 
    </> )
}

export default withTranslation()(MisPacientes)